import classes from '@/components/Shares/Button.module.css';
import { useLingui } from '@lingui/react';
import { Button, Image } from '@mantine/core';
export const ClaimButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Button leftSection={<Image src="/assets/wallet/coins-hand.svg" alt="icon" w={24} h={24} />} mt={24} radius={5} h={46} fw={700} fz={13} tt="uppercase" classNames={classes} mx="auto" type="submit">
      {i18n._('Claim')}
    </Button>;
};